import React from 'react'
import BusinessVerticalHomeComponent from '../components/BusinessVerticalHomeComponent'
import BVertical from '../components/BVertical'
import BlogSection from '../components/BlogSection'

const MarketingPage = () => {
  return (
    <>
      <BusinessVerticalHomeComponent/>
      <BVertical/>
      <BlogSection/>
    </>
  )
}

export default MarketingPage